import { ObjectDb } from './object.db';
import { UserGridItemObject } from '@it2go/types';
import { Injectable } from '@angular/core';
import { userInfoFrag } from '../../utils/type/user.common-type';
import { GridInput } from '@it2go/data-grid';

@Injectable({ providedIn: 'root' })
export class UserDb extends ObjectDb<UserGridItemObject> {

    public tableName: string = 'user';

    protected override columnMap = {
        serviceId: '$.employment.serviceId',
        employment: '$.employment.employmentTypeName',
        organizationId: 'organizations.id',
    };

    protected override joins = {
        employment: 'employments.id',
    };

    protected gqlMethod = 'getUsers';

    protected syncFragment = `
        ${userInfoFrag}
        employments {
            id
        }
        organizations {
            id
        }
    `;

}
